/**
 * 数据中心 → 配料机数据 → 精準度
 * parent = coffee_menu XTSeriesData 1776875108514795520
 * 注：不可用 990420（已占用 ecosystemMall）
 */
export const DISPENSER_PRECISION_MENU_IDS = {
  page: 991132,
  enName: 'dispenserPrecision',
  parentEnName: 'XTSeriesData',
  parentId: 1776875108514795520
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/dispenserPrecision.js